import { userDetail } from "../Action/ActionTypes";

export const userDetailReducer =(state={},action)=>{
    switch (action.type) {
        case userDetail.SAVE_lOGIN_DETAILS:
            return action.payload
        default:
            return state
    }
}